module.exports = "data:image/webp;base64,UklGRtQAAABXRUJQVlA4IMgAAABwBACdASoZABkAPpE6l0eloyIhMAgAsBIJQAHPI3kD7Ex1LknDyKIAKuNR8AD8X8qSmAsSiDXiFY2r/T7JNjKRvk8WhaU3PLYHlPzYzszgIzyyRg3fzH/9bfxb+yKQ///LP/9lv+UXNwdrR74cOJMIO2FE/WunuiAvkVocEPgwvHZZpWcTefku/G1ISCZDqE8dAYu84AgY9nOsbE0QbtVCQII5Cbz94O7N8ghd+KnBO6yTt3H0H4jYIgA+i/b7wB43J0IjkAAAAA=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/color/Papaya_Punch.webp
// module id = umfR
// module chunks = 14